import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

export const selectIntegrations = (state:RootState) => state.integrations.integrations;

export const selectIntegrationById = createSelector(
  [
    selectIntegrations,
    (_:any, props:{ integrationId:string }) => props
  ],
  (integrations, { integrationId }) => {
    return integrations.find(integration => integration._id === integrationId);
  }
);
